import { API_DOMAIN } from '@constants';
import type { STMatrixData } from '@types';
import axios from '@utils/axios';
import {
  $sandTableMatrixMap,
  $sandTableMatrixMapApi,
} from '@stores/sandTableStores';

const fetchSandTableMatrices = async (ids: number | number[]) => {
  let idString: string;
  if (typeof ids === 'number') {
    const data = $sandTableMatrixMap.getState().get(ids);
    if (data) {
      $sandTableMatrixMapApi.add([data]);
      return [data];
    }
    idString = `${ids}`;
  } else {
    idString = ids.join(',');
  }
  const data = await axios.get<STMatrixData[]>(
    `${API_DOMAIN}/matrix/material/info?ids=${idString}`
  );
  $sandTableMatrixMapApi.add(data);
  return data;
};

export default fetchSandTableMatrices;
